import React, { useState, useEffect } from "react";
import { Layout, Menu, message } from "antd";
import { Modal } from "antd";
import cookies from "js-cookie";

import {
  HomeOutlined,
  UserOutlined,
  CalendarOutlined,
  QuestionCircleOutlined,
  BarChartOutlined,
  PieChartOutlined,
  TeamOutlined,
  UpOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { Link, useRouteMatch } from "react-router-dom";

import { Box, IconButton, Typography, useTheme, Collapse } from "@mui/material";
import { tokens } from "../../theme";
import dashboard_pressed from "../../assets/img/Dahsboard_pressed.png";
import dashboard_ico from "../../assets/img/Dashboard.png";
import loan_ico from "../../assets/img/LoanLogo.png";
import loan_pressed from "../../assets/img/LoanLogo_pressed.png";
import analytic_ico from "../../assets/img/Analyticlogo.png";
import analytic_pressed from "../../assets/img/Analyticlogo_pressed.png";
import agreements_ico from "../../assets/img/Agreementlogo.png";
import agreements_pressed from "../../assets/img/Agreementlogo_pressed.png";
import subscription_ico from "../../assets/img/Subscription.png";
import subscription_pressed from "../../assets/img/SubscriptionLogo_pressed.png";
import profile_ico from "../../assets/img/Profile.png";
import profile_pressed from "../../assets/img/Profile_selected.png";
import logout_ico from "../../assets/img/Logout.png";
import LockIcon from "@mui/icons-material/Lock";
import LenderMobileNavigation from "./LenderMobileNavigation";
import Cookies from "js-cookie";
import AccountBoxOutlinedIcon from "@mui/icons-material/AccountBoxOutlined";
import DocumentScannerOutlinedIcon from "@mui/icons-material/DocumentScannerOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import newLogo from "../../pages/smart-lend-frontend/src/img/sl_long_new_logo_wo_beta.png";
import HouseIcon from "@mui/icons-material/House";
import EditNotificationsIcon from "@mui/icons-material/EditNotifications";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import AdminDashboardAds from "../../pages/admin-dashboard/admindashboardads";

const { Sider } = Layout;
const { SubMenu } = Menu;
const options = { day: "numeric", month: "short", year: "numeric" };
const RENTLY_STYLE_MANAGE_CASE_EMAILS = ["lender1@gmail.com"];
const canAccessManageCases = (email) => {
  const normalizedEmail = String(email || "").trim().toLowerCase();
  return (
    normalizedEmail.endsWith("@smart-lend.com") ||
    normalizedEmail.endsWith("@rently.sg") ||
    RENTLY_STYLE_MANAGE_CASE_EMAILS.includes(normalizedEmail)
  );
};

const Item3 = ({
  title,
  title2,
  to,
  icon,
  selected,
  setSelected,
  subMenu,
  icon2,
  onClick, // New prop for onClick function
  disabled, // New prop for disabling button
}) => {
  const match = useRouteMatch(to);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [hovered, setHovered] = useState(false);

  return (
    <Menu.Item
      key={title}
      icon={hovered ? icon : icon2}
      style={{
        marginLeft: "15px",
        marginBottom: "20px",
        paddingLeft: "20px",
        background: hovered ? "#0E5AA5" : "#FFFFFF",
        opacity: 1,
        width: "80%",
        color: hovered ? "#FFFFFF" : "#0E5AA5",
        boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
      }}
      onMouseEnter={() => setHovered(true)} // set the state hovered to true  when mouse enter
      onMouseLeave={() => setHovered(false)} // set the state hovered to false  when mouse leave
      onClick={(event) => onClick(event)} // Attaching onClick here
      disabled={disabled} // Attaching disabled here
    >
      <div>
        <Typography
          style={{
            color: hovered ? "#FFFFFF" : "rgba(0,0,0,0.6)",
            fontFamily: "Poppins, sans-serif",
            fontWeight: 700,
            fontSize: "13px",
            textAlign: "Left",
          }}
        >
          {title}
        </Typography>

        <Typography
          style={{
            color: match ? "#0E5AA5" : "rgba(0,0,0,0.6)",
            fontFamily: "Manrope, sans-serif",
            fontWeight: "800",
            fontSize: "13px",
            textAlign: "Left",
            paddingLeft: "20px",
          }}
        >
          {title2}
        </Typography>
      </div>
      <Link to={to} />
    </Menu.Item>
  );
};

const Sidebar = (to) => {
  const match = useRouteMatch(to);
  const [isLoading, setIsLoading] = useState(false);
  const [notificationSettingModalIsOpen, setNotificationSettingModalIsOpen] =
    useState(false);
  const [lenderemailField, setLenderEmailField] = useState("");
  const [lenderEmailList, setLenderEmailList] = useState([]);
  const [lenderWhatsapplField, setLenderWhatsappField] = useState("");
  const [lenderWhatsapplList, setLenderWhatsappList] = useState([]);
  const [updatedField, setUpdatedField] = useState(false);
  const [fieldMaxError, setFieldMaxError] = useState(false);

  const getUrlParameter = (name) => {
    name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    const results = regex.exec(window.location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  };

  // Get the token parameter from the URL
  const tokenParam = getUrlParameter("token");

  const handleEmailInputChange = (e) => {
    setUpdatedField(true);
    const value = e.target.value;
    setLenderEmailField(value);

    const validEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const allEmails = value
      .split(",")
      .map((email) => email.trim())
      .filter((email) => validEmailRegex.test(email)); // Only valid emails

    if (allEmails.length > 3) {
      setFieldMaxError(true);
      setLenderEmailList(allEmails.slice(0, 3));
    } else {
      setFieldMaxError(false);
      setLenderEmailList(allEmails);
    }
  };

  const handleWhatsappInputChange = (e) => {
    setUpdatedField(true);
    const value = e.target.value;
    setLenderWhatsappField(value);

    const validWhatsappRegex = /^(65|60)\d{8}$/;

    const allWhatsapp = value
      .split(",")
      .map((whatsapp) => whatsapp.trim())
      .filter((whatsapp) => validWhatsappRegex.test(whatsapp)); // Only valid numbers

    if (allWhatsapp.length > 3) {
      setFieldMaxError(true);
      setLenderWhatsappList(allWhatsapp.slice(0, 3));
    } else {
      setFieldMaxError(false);
      setLenderWhatsappList(allWhatsapp);
    }
  };

  const [userDetails, setUserDetails] = useState(null);

  const getUserDetails = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/profile/getUserDetails",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token") || tokenParam}`,
          },
        }
      );
      if (response.status === 200) {
        const json = await response.json();
        setUserDetails(json.User);
        setUserEmail(json.User?.email || "");
        if (json.User?.email) {
          Cookies.set("email", json.User.email);
        }
        if (json.User.lender_emails !== null) {
          const parsedEmails = JSON.parse(json.User.lender_emails);

          setLenderEmailList(parsedEmails);
          setLenderEmailField(parsedEmails.join(", "));
        }
        if (json.User.lender_whatsapp !== null) {
          const parsedWhatsapp = JSON.parse(json.User.lender_whatsapp);

          setLenderWhatsappList(parsedWhatsapp);
          setLenderWhatsappField(parsedWhatsapp.join(", "));
        }
      } else if (response.status === 401) {
        cookies.remove("token");
        window.location.href = "/auth/signin";
      }
    } catch (error) {
      console.error(error);
    }
  };

  const updateLenderEmail = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/changeLenderEmails",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({
            lender_emails: JSON.stringify(lenderEmailList),
            lender_whatsapp: JSON.stringify(lenderWhatsapplList),
          }),
        }
      );
      if (response.status === 200) {
        setUpdatedField(false);
        message.success("Email list updated!");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getUserDetails();
  }, []);
  const [userEmail, setUserEmail] = useState(Cookies.get("email"));
  const [anyUnread, setAnyUnread] = useState(false);
  const Item = ({
    title,
    title2,
    to,
    icon,
    selected,
    setSelected,
    subMenu,
    icon2,
    beta,
  }) => {
    const match = useRouteMatch(to);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    useEffect(() => {
      setUserEmail(Cookies.get("email"));
      console.log(Cookies.get("email"));
    }, [Cookies.get("email")]);

    return (
      <Menu.Item
        // key={title}
        icon={match ? icon : icon2}
        style={{
          paddingLeft: match ? "24px" : "30px",
          borderLeft: match ? "6px solid #0E5AA5" : "none",
          marginLeft: "-0.03vw",
          borderRadius: "0px 8px 8px 0px",
          height: title ? "35px" : "30px",
          display: "flex",
          alignItems: "center",
        }}
        onClick={() => setSelected(title)}
      >
        <div>
          {title ? (
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: 30,
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  color: match ? "#0E5AA5" : "rgba(0,0,0,0.6)",
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 700,
                  fontSize: "13px",
                  textAlign: "Left",
                  margin: "0px",
                }}
              >
                {title}
              </p>
              {anyUnread && title === "Messages" ? (
                <div
                  className="blink"
                  style={{
                    position: "absolute",
                    width: 7,
                    height: 7,
                    borderRadius: "50%",
                    background: "#7057F6",
                    bottom: 14,
                    right: 14,
                  }}
                />
              ) : null}

              {beta ? (
                <div
                  style={{
                    background: "rgb(14, 90, 165)",
                    color: "white",
                    padding: "8px 15px",
                    fontSize: "10px",
                    borderRadius: "8px",
                    lineHeight: "10px",
                  }}
                >
                  Beta
                </div>
              ) : null}
            </div>
          ) : (
            <></>
          )}

          {title2 ? (
            <div style={{ display: "flex", alignItems: "flex-start", gap: 30 }}>
              <p
                style={{
                  color: match ? "#0E5AA5" : "rgba(0,0,0,0.6)",
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 700,
                  fontSize: "12px",
                  textAlign: "Left",
                  paddingLeft: "35px",
                  margin: "0px",
                }}
              >
                {title2}
              </p>
              {anyUnread && title === "Messages" ? (
                <div
                  className="blink"
                  style={{
                    position: "absolute",
                    width: 7,
                    height: 7,
                    borderRadius: "50%",
                    background: "#7057F6",
                    bottom: 14,
                    right: 14,
                  }}
                />
              ) : null}
              {needPaymentAttention && title2 === "Payments" ? (
                <div
                  className="blink"
                  style={{
                    position: "absolute",
                    width: 7,
                    height: 7,
                    borderRadius: "50%",
                    background: "#7057F6",
                    bottom: 14,
                    right: 14,
                  }}
                />
              ) : null}
            </div>
          ) : (
            <></>
          )}
        </div>
        <Link to={to} />
      </Menu.Item>
    );
  };
  const handleLogout = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/user/logout",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${cookies.get("token")}`,
          },
          body: JSON.stringify({ user: "id" }),
        }
      );
      if (!response.ok) {
        cookies.remove("token");
        window.location.href = "/auth/signin";
      }
      // Clear user session and navigate to login page
      cookies.remove("token");
      window.location.href = "/auth/signin";
    } catch (error) {
      console.error(error);
      cookies.remove("token");
      window.location.href = "/auth/signin";
    }
    setIsLoading(false);
  };
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");

  const toggleCollapsed = () => {
    setIsCollapsed(isCollapsed);
  };

  const [screenWidth, setScreenWidth] = useState(() => window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const [subscriptionPlan, setSubsciptionPlan] = useState(
    Cookies.get("subscription")
      ? JSON.parse(JSON.parse(Cookies.get("subscription")))
      : null
  );


  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await fetch(
  //         "https://www.smart-lend.com/api/subcription/getSubscription",
  //         {
  //           method: "GET",
  //           headers: {
  //             Authorization: "Bearer " + Cookies.get("token"),
  //             Accept: "application/json",
  //           },
  //         }
  //       );
  //       const json = await response.json();
  //       // console.log(JSON.parse(JSON.parse(Cookies.get("subscription"))));
  //       if (json.subscription) {
  //         console.log(JSON.parse(json.subscription));
  //         setSubsciptionPlan(JSON.parse(json.subscription));
  //         Cookies.set("subscription", JSON.stringify(json.subscription));
  //       } else {
  //         setSubsciptionPlan(null);
  //         Cookies.remove("subscription");
  //       }
  //     } catch (error) {
  //       setSubsciptionPlan(null);
  //       Cookies.remove("subscription");
  //     }
  //   };
  //   fetchData();
  // }, []);

  const currentDate = new Date();
  const checkReadId = (data, currentUserId) => {
    if (!Array.isArray(data) || !currentUserId) {
      setAnyUnread(false);
      return;
    }

    const isRead = (value) =>
      value === true || value === 1 || value === "1" || value === "true";

    const hasUnread = data.some((conversation) => {
      if (conversation.user_id1 === currentUserId) {
        return !isRead(conversation.read_id1);
      }

      if (conversation.user_id2 === currentUserId) {
        return !isRead(conversation.read_id2);
      }

      return false;
    });

    setAnyUnread(hasUnread);
  };

  const retrieveMessage = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/message/getMessage",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token") || tokenParam}`,
          },
        }
      );

      const json = await response.json();
      if (response.status === 200) {
        const data = [...json.data];
        console.log("updated new data");
        checkReadId(data, json.user_id);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      retrieveMessage();
    }, 6000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    retrieveMessage();
  }, []);

  const [needPaymentAttention, setNeedPaymentAttention] = useState(false);

  const viewLenderPayments = async () => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/viewLenderPayments`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token") || tokenParam}`,
          },
        }
      );
      const json = await response.json();
      let updatingNeedPaymentAttention = false;
      for (const repay of json.Payments) {
        const repayments = repay.repayments;
        for (const payments of repayments) {
          if (
            payments.status === "pending" &&
            new Date(payments.repay_due_date) < new Date()
          ) {
            updatingNeedPaymentAttention = true;
          }
        }
      }
      console.log(updatingNeedPaymentAttention);
      setNeedPaymentAttention(updatingNeedPaymentAttention);
    } catch (error) {
      console.error("Error retrieving loan detail:", error);
    }
  };

  useEffect(() => {
    viewLenderPayments();
  }, []);

  return (
    <>
          <Modal
            width={window.innerWidth < 1200 ? "100%" : "40vw"}
            style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
            open={notificationSettingModalIsOpen}
            onCancel={() => {
              setNotificationSettingModalIsOpen(false);
            }}
            footer={null}
          >
            <div style={{ fontWeight: 700, fontSize: 30, color: "#142C44CC" }}>
              Notification Settings
            </div>
            <div
              style={{
                fontWeight: 400,
                fontSize: 12,
                color: "rgb(100,100,100)",
                marginTop: "0px",
              }}
            >
              You may add other emails here to allow secondary email address to
              receive every notification from the primary email address.
            </div>
            {lenderEmailList ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "10px",
                  marginTop: "15px",
                }}
              >
                {lenderEmailList.map((dat, index) => (
                  <div
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                      background: "rgb(100,100,100)",
                      color: "white",
                    }}
                    key={index}
                  >
                    {dat}
                  </div>
                ))}
              </div>
            ) : null}
            <textarea
              style={{
                marginTop: "15px",
                width: "100%",
                height: "100px",
                padding: "8px",
                border: "1px solid lightgrey",
                outline: "none",
              }}
              placeholder="Insert email here seperated by commas"
              value={lenderemailField}
              onChange={handleEmailInputChange}
            />
            {lenderWhatsapplList ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "10px",
                  marginTop: "15px",
                }}
              >
                {lenderWhatsapplList.map((dat, index) => (
                  <div
                    style={{
                      padding: "5px",
                      borderRadius: "5px",
                      background: "rgb(100,100,100)",
                      color: "white",
                    }}
                    key={index}
                  >
                    {dat}
                  </div>
                ))}
              </div>
            ) : null}
            <textarea
              style={{
                marginTop: "15px",
                width: "100%",
                height: "100px",
                padding: "8px",
                border: "1px solid lightgrey",
                outline: "none",
              }}
              placeholder="Insert whatsapp number here seperated by commas, whatsapp number must all start with country code"
              value={lenderWhatsapplField}
              onChange={handleWhatsappInputChange}
            />
            {fieldMaxError ? (
              <div
                style={{ color: "red", fontWeight: 600, marginTop: "10px" }}
                className="blink"
              >
                To avoid slowing down the service, you may only add a maximum of
                3 emails notifialbe and 3 whatsapp numnbers.
              </div>
            ) : null}
            {updatedField ? (
              <div style={{ display: "flex" }}>
                <div
                  className="mui_button"
                  style={{
                    width: "100%",
                    border: "none",
                    borderRadius: "50px",
                    padding: "6px 0px",
                    fontSize: "12px",
                    margin: "10px 0px 0px 0px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#ffffff",
                    background: "#115CA6",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    updateLenderEmail();
                  }}
                >
                  Save
                </div>
              </div>
            ) : null}
          </Modal>
      {screenWidth > 1200 ? (
        <Box
          className="sl-lender-sidebar"
          display="flex"
          flexDirection="column"
          justifyContent="flex-start"
          style={{
            height: "100vh",
            backgroundColor: "#F1F6F9",
          }}
        >

          {/* LOGO AND MENU ICON */}
          <Menu
            className="sl-sidebar-main"
            // theme="dark"
            mode="inline"
            defaultSelectedKeys={[selected]}
            selectedKeys={[selected]}
            style={{
              background: "#F1F6F9",
              width: "250px",
              position: "relative",
              zIndex: 3,  
            }}
          >
            <Menu.Item className="sl-sidebar-logo-item" style={{ marginTop: "30px" }}>
              {!isCollapsed && (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  {/* <Typography
                    variant="h3"
                    color={colors.grey[930]}
                    opacity="1"
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: "800",
                      fontSize: "25px",
                      textAlign: "center",
                    }}
                  >
                    SmartLend.
                  </Typography> */}
                  <img
                    src={newLogo}
                    style={{ width: "100%", objectFit: "contain" }}
                  />
                </Box>
              )}
            </Menu.Item>
            <div style={{ paddingBottom: "32px" }}></div>
            <Item
              title="Dashboard"
              to="/dashboard"
              icon={
                <img src={dashboard_pressed} alt="" width={12} height={12} />
              }
              icon2={<img src={dashboard_ico} alt="" width={12} height={12} />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Messages"
              to="/l-messages"
              icon={
                <img src={dashboard_pressed} alt="" width={12} height={12} />
              }
              icon2={<img src={dashboard_ico} alt="" width={12} height={12} />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Loan"
              to="/loan-request-grid"
              icon={<img src={loan_pressed} alt="" width={12} height={12} />}
              icon2={<img src={loan_ico} alt="" width={12} height={12} />}
              selected={selected}
              setSelected={setSelected}
              onClick={() => {
                setSelected("Loan");
              }}
            >
              <Link
                to="/loan"
                style={{ color: "inherit", textDecoration: "none" }}
              />
            </Item>

            <Item
              title2="Loan Request"
              match={"loan-request" || "loan-request-grid"}
              to="/loan-request-grid"
              icon={" "}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title2="Pending Acceptance"
              to="/pending-acceptance"
              icon={" "}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title2="Accepted Loans"
              to="/accepted-loans"
              icon={" "}
              selected={selected}
              setSelected={setSelected}
            />
            {screenWidth > 800 ? (
              <Item
                title2="Payments"
                to="/l-payments"
                icon={" "}
                selected={selected}
                setSelected={setSelected}
              />
            ) : null}
            {/* </SubMenu> */}

            {screenWidth > 800 ? (
              <Item
                title="Analytics"
                to="/analytics"
                icon={
                  <img src={analytic_pressed} alt="" width={17} height={17} />
                }
                icon2={<img src={analytic_ico} alt="" width={17} height={17} />}
                selected={selected}
                setSelected={setSelected}
              />
            ) : null}
            {/* <Item
              title="Agreements"
              to="/agreements"
              icon={
                <img src={agreements_pressed} alt="" width={17} height={17} />
              }
              icon2={<img src={agreements_ico} alt="" width={17} height={17} />}
              selected={selected}
              setSelected={setSelected}
            /> */}
            <Item
              title="My Profile"
              to="/l-profile"
              icon={
                <AccountBoxOutlinedIcon
                  style={{
                    fontSize: 18,
                    marginLeft: "-2px",
                    color: "rgb(14, 90, 165)",
                  }}
                />
              }
              icon2={
                <AccountBoxOutlinedIcon
                  style={{
                    fontSize: 18,
                    marginLeft: "-2px",
                    color: "rgba(0,0,0,0.4)",
                  }}
                />
              }
              selected={selected}
              setSelected={setSelected}
            />
            {screenWidth > 800 ? (
              <Item
                title="Doc Builder"
                to="/l-document-builder"
                icon={
                  <DocumentScannerOutlinedIcon
                    style={{
                      fontSize: 18,
                      marginLeft: "-2px",
                      color: "rgb(14, 90, 165)",
                    }}
                  />
                }
                icon2={
                  <DocumentScannerOutlinedIcon
                    style={{
                      fontSize: 18,
                      marginLeft: "-2px",
                      color: "rgba(0,0,0,0.4)",
                    }}
                  />
                }
                selected={selected}
                setSelected={setSelected}
              />
            ) : null}
            {screenWidth > 800 ? (
              <Item
                title="Bank Statement Portal"
                to="/l-bank-statement-portal"
                icon={
                  <AccountBalanceOutlinedIcon
                    style={{
                      fontSize: 18,
                      marginLeft: "-2px",
                      color: "rgb(14, 90, 165)",
                    }}
                  />
                }
                icon2={
                  <AccountBalanceOutlinedIcon
                    style={{
                      fontSize: 18,
                      marginLeft: "-2px",
                      color: "rgba(0,0,0,0.4)",
                    }}
                  />
                }
                selected={selected}
                setSelected={setSelected}
              />
            ) : null}
            {screenWidth > 800 && canAccessManageCases(userEmail) ? (
              <Item
                title="Manage Cases"
                to="/l-manage-cases"
                icon={
                  <BusinessCenterOutlinedIcon
                    style={{
                      fontSize: 18,
                      marginLeft: "-2px",
                      color: "rgb(14, 90, 165)",
                    }}
                  />
                }
                icon2={
                  <BusinessCenterOutlinedIcon
                    style={{
                      fontSize: 18,
                      marginLeft: "-2px",
                      color: "rgba(0,0,0,0.4)",
                    }}
                  />
                }
                selected={selected}
                setSelected={setSelected}
              />
            ) : null}
            {/* {userEmail === "Lender1@gmail.com" ||
            userEmail === "MCROY@SMART-LEND.COM" ? (
              screenWidth > 800 ? (
                <Item
                  title="Personal Loan"
                  to="/l-personal-loan-marketplace"
                  beta={true}
                  icon={
                    <img
                      src={loan_pressed}
                      alt=""
                      width={12}
                      height={12}
                      style={{ opacity: 1 }}
                    />
                  }
                  icon2={
                    <img
                      src={loan_ico}
                      alt=""
                      width={12}
                      height={12}
                      style={{ opacity: 0.7 }}
                    />
                  }
                  selected={selected}
                  setSelected={setSelected}
                />
              ) : null
            ) : null} */}

            {userEmail === "Lender1@gmail.com" ||
            userEmail === "MCROY@SMART-LEND.COM" ? (
              screenWidth > 800 ? (
                <Item
                  title="Manual Loans"
                  to="/l-manual-giro"
                  beta={false}
                  icon={
                    <img src={loan_pressed} alt="" width={12} height={12} />
                  }
                  icon2={<img src={loan_ico} alt="" width={12} height={12} />}
                  selected={selected}
                  setSelected={setSelected}
                />
              ) : null
            ) : null}
            {/* <Item
              title="Subscription"
              to="/subscription"
              icon={
                <img src={subscription_pressed} alt="" width={17} height={17} />
              }
              icon2={
                <img src={subscription_ico} alt="" width={17} height={17} />
              }
              selected={selected}
              setSelected={setSelected}
            /> */}
          </Menu>
          <Menu
            className="sl-sidebar-bottom"
            mode="inline"
            defaultSelectedKeys={[selected]}
            selectedKeys={[selected]}
            style={{
              background: "#F1F6F9",
              display: "flex",
              flexDirection: "column",
              justifyContent: "end",
              height: "100%",
              position: "relative",
              zIndex: 2,  
            }}
          >
            {/* <div
              style={{
                marginLeft: "15px",
                marginBottom: "10px",
                paddingLeft: "20px",
                background: "#FFFFFF",
                opacity: 1,
                width: "80%",
                color: "lightgrey",
                boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",

                padding: "7px 25px",
                borderRadius: "10px",
                textAlign: "left",
                position: "relative",
                height: "80px",
                lineHeight: "20px",
              }}
            >
              {subscriptionPlan ? (
                <div
                  className="blink"
                  style={{
                    position: "absolute",
                    top: 15,
                    right: 15,
                    background:
                      subscriptionPlan.validity &&
                      new Date(subscriptionPlan.validity) < currentDate
                        ? "red"
                        : "green",
                    boxShadow:
                      subscriptionPlan.validity &&
                      new Date(subscriptionPlan.validity) < currentDate
                        ? "0px 0px 10px red"
                        : "0px 0px 10px green",
                    height: "7px",
                    width: "7px",
                    borderRadius: "10px",
                  }}
                ></div>
              ) : null}
              <div style={{ margin: "5px 0px 0px 0px" }}>Subscription</div>
              <div
                style={{
                  width: "100%",
                  color: "#142C44CC",
                  fontSize: "20px",
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "800",
                  margin: "0px 0px 0px 0px",
                }}
              >
                {subscriptionPlan
                  ? `${subscriptionPlan.plan} Plan`
                  : "You have no plans"}
              </div>
              {subscriptionPlan ? (
                subscriptionPlan.validity &&
                new Date(subscriptionPlan.validity) < currentDate ? (
                  <div
                    style={{
                      color: "red",
                      margin: "18px 0px 0px 0px",
                      fontSize: "12px",
                      fontWeight: "600",
                      margin: "0px 0px 0px 0px",
                    }}
                  >
                    Subscription Expired
                  </div>
                ) : (
                  <div
                    style={{
                      color: "grey",
                      margin: "18px 0px 0px 0px",
                      fontSize: "12px",
                      margin: "0px 0px 0px 0px",
                    }}
                  >
                    Valid till:{" "}
                    {new Date(subscriptionPlan.validity).toLocaleDateString(
                      "en-US",
                      options
                    )}
                  </div>
                )
              ) : null}
            </div> */}
            {/* <Item
              title="Profile"
              to="/profile"
              icon={
                <img
                  className="odd_icon_setting"
                  src={profile_pressed}
                  alt=""
                  width={12}
                  height={12}
                />
              }
              icon2={
                <img
                  className="odd_icon_setting"
                  src={profile_ico}
                  alt=""
                  width={12}
                  height={12}
                />
              }
              selected={selected}
              setSelected={setSelected}
            /> */}
            <div className="sl-sidebar-ad">
              <AdminDashboardAds />
            </div>
            <Item3
              title="Notifications"
              icon={
                <EditNotificationsIcon
                  className="colored_white_icon"
                  style={{ fontSize: "18px", marginLeft: "-3px" }}
                />
              }
              icon2={
                <EditNotificationsIcon
                  style={{
                    fontSize: "18px",
                    marginLeft: "-3px",
                    color: "rgba(0,0,0,0.5)",
                  }}
                />
              }
              to="#"
              onClick={(event) => setNotificationSettingModalIsOpen(event)}
              disabled={isLoading}
            />
            <Item3
              title="Log Out"
              icon={
                <LockIcon
                  className="colored_white_icon"
                  style={{ fontSize: "18px", marginLeft: "-3px" }}
                />
              }
              icon2={
                <LockIcon
                  style={{
                    fontSize: "18px",
                    marginLeft: "-3px",
                    color: "rgba(0,0,0,0.5)",
                  }}
                />
              }
              to="#"
              onClick={(event) => handleLogout(event)}
              disabled={isLoading}
            />
          </Menu>
        </Box>
      ) : (
        <LenderMobileNavigation
          canManageCases={canAccessManageCases(userEmail)}
          canManageManualLoans={["Lender1@gmail.com", "MCROY@SMART-LEND.COM"].includes(userEmail)}
          isLoggingOut={isLoading}
          onLogout={handleLogout}
          onOpenNotifications={() => setNotificationSettingModalIsOpen(true)}
        />
      )}
    </>
  );
};
export default Sidebar;
